import React, { useState } from "react";
import DialogSkeleton from "./dialogSkeleton";
import { Shortcut, ShortcutGroup } from "modules/shortcuts/models";
import ShortcutGroupSearch from "./shortcutGroupSearch";
import DialogField from "modules/common/components/dialogField";
import { Grid } from "@mui/material";

interface IMoveShortcutsDialogProps {
    show: boolean;
    onClose: () => void;
    onMoveSelectedShortcuts: (groupId: string, selectedShortcuts: Shortcut[]) => void;
    selectedShortcuts: Shortcut[];
}

const MoveShortcutsDialog: React.FC<IMoveShortcutsDialogProps> = ({
    show,
    onClose,
    onMoveSelectedShortcuts,
    selectedShortcuts,
}) => {
    const [selectedGroup, setSelectedGroup] = useState<ShortcutGroup | undefined>(undefined);

    const isNotFilled = !selectedGroup;

    const getGroupField = (): JSX.Element => 
        <ShortcutGroupSearch
            shortcutGroupValue={selectedGroup}
            onChangeShortcutGroupValue={newGroup => setSelectedGroup(newGroup ?? undefined)}
        />;

    const dialogTitle = `Move ${selectedShortcuts.length > 1 ? `${selectedShortcuts.length} shortcuts` : selectedShortcuts[0]?.name}`;

    return <DialogSkeleton
        show={show}
        onClose={onClose}
        onDialogActionButtonClick={() => onMoveSelectedShortcuts(selectedGroup!.id, selectedShortcuts)}
        dialogTitle={dialogTitle.length > 55 ? dialogTitle.substring(0, 52) + "..." : dialogTitle}
        dialogActionButtonLabel="Move"
        disableActionButton={isNotFilled}
    >
        <Grid container
            alignItems={"center"}
            className="move-shortcut-dialog-body-grid-container"
        >
            <DialogField
                fieldName="To shortcut group"
                fieldInput={getGroupField()}
                mandatory
            />
        </Grid>
    </DialogSkeleton>;
};

export default MoveShortcutsDialog;
